module.exports = __webpack_public_path__ + "39ef978aa9c17c27bf10f6e70aede581.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons.png
// module id = 238
// module chunks = 1